import React from "react";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle } from "@mui/material/";
import { useSelector } from "react-redux";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const CheckedAssetInfo = () => {
    const { t } = useTranslation();
    const { auditAssets } = useSelector((state) => state);

    const auditAsset = auditAssets.item;

    const generateIconStatus = (status) => {
        if (status && status === 2)
            return {
                text: "seen",
                severity: "success",
                icon: <VisibilityIcon color="success" />,
            };
        if (status && status === 3)
            return {
                text: "excluded",
                severity: "error",
                icon: <VisibilityOffIcon color="error" />,
            };
        if (!status || status)
            return {
                text: "synced",
                severity: "info",
                icon: <SyncAltIcon color="info" />,
            };
    };

    const currentStatus = generateIconStatus(auditAsset.status);

    return (
        <Alert
            icon={currentStatus.icon}
            sx={{ p: 2 }}
            severity={currentStatus.severity}
        >
            <AlertTitle textTransform="capitalize">
                {t(currentStatus.text)}
            </AlertTitle>
            {`${t("messages.editCheckedAsset")} ${currentStatus.text}.`}
        </Alert>
    );
};

export default CheckedAssetInfo;
